import { render } from "./ModifyShipment.vue?vue&type=template&id=33ccb4b2&scoped=true"
import script from "./ModifyShipment.vue?vue&type=script&lang=js"
export * from "./ModifyShipment.vue?vue&type=script&lang=js"

import "./ModifyShipment.vue?vue&type=style&index=0&id=33ccb4b2&lang=css"
import "./ModifyShipment.vue?vue&type=style&index=1&id=33ccb4b2&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ccb4b2"]])

export default __exports__